import { PartyPopper, ArrowRight } from "lucide-react";
import { t } from "@/i18n";

const ENCOURAGEMENT_KEYS = [
  "interexerciserecap.encouragement_1",
  "interexerciserecap.encouragement_2",
  "interexerciserecap.encouragement_3",
  "interexerciserecap.encouragement_4",
];

/* Écran affiché entre deux exercices : petit bilan de l'exercice qui vient
   de se terminer, encouragement, dinars gagnés, temps restant estimé. Si
   l'utilisateur quitte ici, tout est déjà sauvegardé côté serveur (chaque
   exercice est soumis individuellement). */
export default function InterExerciseRecap({
  itemRecap,
  remainingCount,
  remainingMinutes,
  runningTotal,
  onContinue,
  onQuit,
}) {
  const phraseKey =
    ENCOURAGEMENT_KEYS[Math.floor(Math.random() * ENCOURAGEMENT_KEYS.length)];
  const phrase = t(phraseKey);
  return (
    <div className="max-w-md mx-auto text-center py-10">
      <PartyPopper size={40} className="mx-auto mb-3 text-amber-500" />
      <h2 className="font-head text-xl font-bold mb-1">{phrase}</h2>
      <p className="text-sm text-muted-foreground mb-5">
        {itemRecap.correct}/{itemRecap.total}{" "}
        {t("interexerciserecap.bonnes_reponses")}
      </p>
      <div className="text-4xl font-head font-extrabold text-amber-500 mb-1">
        {itemRecap.dinars_earned === null
          ? "…"
          : `+${itemRecap.dinars_earned} 🪙`}
      </div>
      <p className="text-xs text-muted-foreground mb-6">
        {runningTotal} {t("interexerciserecap.gagnes_depuis_le_debut_de_la")}
      </p>
      {remainingCount > 0 ? (
        <p className="text-sm text-muted-foreground mb-6">
          {t("interexerciserecap.encore")} {remainingCount}{" "}
          {t("interexerciserecap.exercice_s", {
            s: remainingCount > 1 ? "s" : "",
          })}{" "}
          {t("interexerciserecap.environ")} {remainingMinutes}{" "}
          {t("interexerciserecap.min")}
        </p>
      ) : (
        <p className="text-sm text-muted-foreground mb-6">
          {t("interexerciserecap.dernier_exercice_fait_direction_le_bilan")}
        </p>
      )}
      <button
        onClick={onContinue}
        className="w-full py-4 rounded-2xl bg-primary text-primary-foreground font-bold flex items-center justify-center gap-2 mb-3"
      >
        {t("exerciseblock.continuer")} <ArrowRight size={18} />
      </button>
      <button
        onClick={onQuit}
        className="text-xs text-muted-foreground hover:underline"
      >
        {t("interexerciserecap.reprendre_plus_tard_c_est_deja")}
      </button>
    </div>
  );
}
